import { render, staticRenderFns } from "./dormVolume.vue?vue&type=template&id=8396d23e"
import script from "./dormVolume.vue?vue&type=script&lang=js"
export * from "./dormVolume.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports